import { setInitialState } from "../../../../utils/reducerOperations";
export function Default() {
    return {
        renamePeopleApi: setInitialState(),
        deletePeopleApi: setInitialState(),
    };
}
